import Nav0 from './Nav0/template.config';
import Nav1 from './Nav1/template.config';
import Nav2 from './Nav2/template.config';
import Nav3 from './Nav3/template.config';

import Banner0 from './Banner0/template.config';
import Banner1 from './Banner1/template.config';
import Banner2 from './Banner2/template.config';
import Banner3 from './Banner3/template.config';
import Banner4 from './Banner4/template.config';
import Banner5 from './Banner5/template.config';
import Banner6 from './Banner6/template.config';
import Banner7 from './Banner7/template.config';

import Content0 from './Content0/template.config';
import Content1 from './Content1/template.config';
import Content2 from './Content2/template.config';
import Content3 from './Content3/template.config';
import Content4 from './Content4/template.config';
import Content5 from './Content5/template.config';
import Content6 from './Content6/template.config';
import Content7 from './Content7/template.config';
import Content8 from './Content8/template.config';
import Content9 from './Content9/template.config';
import Content10 from './Content10/template.config';
import Content11 from './Content11/template.config';
import Content12 from './Content12/template.config';
import Content13 from './Content13/template.config';

import Feature6 from './Feature6/template.config';
import Feature7 from './Feature7/template.config';
import Feature8 from './Feature8/template.config';
import Feature9 from './Feature9/template.config';
import Feature98 from './Feature98/template.config';
import Feature99 from './Feature99/template.config';
import Feature10 from './Feature10/template.config';
import Feature12 from './Feature12/template.config';
import Feature13 from './Feature13/template.config';
import Feature14 from './Feature14/template.config';
import Feature15 from './Feature15/template.config';
import Feature11 from './Feature11/template.config';
import Feature16 from './Feature16/template.config';
import Feature18 from './Feature18/template.config';
import Feature17 from './Feature17/template.config';
import Feature19 from './Feature19/template.config';
import Feature20 from './Feature20/template.config';
import Feature21 from './Feature21/template.config';
import Feature22 from './Feature22/template.config';
import Feature23 from './Feature23/template.config';
import Feature24 from './Feature24/template.config';
import Feature25 from './Feature25/template.config';
import Feature26 from './Feature26/template.config';

import Pricing0 from './Pricing0/template.config';
import Pricing1 from './Pricing1/template.config';
import Pricing2 from './Pricing2/template.config';
import Pricing3 from './Pricing3/template.config';

import Teams0 from './Teams0/template.config';
import Teams1 from './Teams1/template.config';
import Teams2 from './Teams2/template.config';
import Teams3 from './Teams3/template.config';

import Footer0 from './Footer0/template.config';
import Footer1 from './Footer1/template.config';
import Footer2 from './Footer2/template.config';
import Footer3 from './Footer3/template.config';
import Footer4 from './Footer4/template.config';

export default {
  Nav0,
  Nav1,
  Nav2,
  Nav3,
  Banner0,
  Banner1,
  Banner2,
  Banner3,
  Banner4,
  Banner5,
  Banner6,
  Banner7,
  Content0,
  Content1,
  Content2,
  Content3,
  Content4,
  Content5,
  Content6,
  Content7,
  Content8,
  Content9,
  Content10,
  Content11,
  Content12,
  Content13,
  Pricing0,
  Pricing1,
  Pricing2,
  Pricing3,
  Teams0,
  Teams1,
  Teams2,
  Teams3,
  Teams4: Content8,
  Contact0: Content10,
  Feature0: Content0,
  Feature1: Content1,
  Feature2: Content2,
  Feature3: Content3,
  Feature4: Content6,
  Feature5: Content7,
  Feature6,
  Feature7,
  Feature8,
  Feature9,
  Feature98,
  Feature99,
  Feature10,
  Feature12,
  Feature13,
  Feature14,
  Feature15,
  Feature11,
  Feature16,
  Feature18,
  Feature17,
  Feature19,
  Feature20,
  Feature21,
  Feature22,
  Feature23,
  Feature24,
  Feature25,
  Feature26,
  Footer0,
  Footer1,
  Footer2,
  Footer3,
  Footer4,
};
